import { useMemo, useRef } from 'react';

const INTERACTIVE_SELECTOR = 'button, a, input, textarea, select, [role="button"], [contenteditable="true"]';

export function useSwipeNavigation(items, activeItem, setActiveItem, options = {}) {
  const startRef = useRef(null);
  const threshold = options.threshold || 64;
  const maxVertical = options.maxVertical || 56;

  return useMemo(() => ({
    onTouchStart(event) {
      if (event.target?.closest?.(INTERACTIVE_SELECTOR)) {
        startRef.current = null;
        return;
      }
      const touch = event.touches?.[0];
      if (!touch) return;
      startRef.current = { x: touch.clientX, y: touch.clientY };
    },
    onTouchEnd(event) {
      const start = startRef.current;
      startRef.current = null;
      if (!start) return;

      const touch = event.changedTouches?.[0];
      if (!touch) return;

      const dx = touch.clientX - start.x;
      const dy = touch.clientY - start.y;
      if (Math.abs(dx) < threshold || Math.abs(dy) > maxVertical) return;

      const currentIndex = items.indexOf(activeItem);
      if (currentIndex < 0) return;

      const nextIndex = dx < 0
        ? Math.min(items.length - 1, currentIndex + 1)
        : Math.max(0, currentIndex - 1);

      if (nextIndex !== currentIndex) setActiveItem(items[nextIndex]);
    },
    onTouchCancel() {
      startRef.current = null;
    },
  }), [activeItem, items, maxVertical, setActiveItem, threshold]);
}
